import React from 'react';
import WaterMeterInstallationPage from '../../water-meter-installation-page';

import wiringDiagram from '../../../../assets/product-interaction/joys500/joys500_wiring.jpg';

const JOYS500Installation = () => (
  <WaterMeterInstallationPage
    model="JOYS500"
    backUrl="/product/joys500"
    wiringDiagram={wiringDiagram}
    wiringAlt="JOYS500 光电直读水表通过 M-BUS 接入 GW214 采集器接线图"
  />
);

export default JOYS500Installation;
